<script setup>
import ArgonButton from "@/components/ArgonButton.vue";
import {computed, ref} from "vue";
import { useStore } from "vuex";
import {ElNotification} from "element-plus";
import {CheckUser} from "@/assets/js/Help";
const store = useStore();
const addBank = ref(false);
const BankList = ref([]);
const IsWorking = ref([]);
const emit = defineEmits(['Updated']);
const ABank = ref({
  type: "",
  Iban:"",
  BankName:"",
  SortCode:"",
  AccountNumber:"",
  WalletAddress:"",
  WalletNetwork:"",
  Token:""
});
const AdminData = computed(() => store.state.currAdmin);
BankList.value= AdminData.value.BankDetails?AdminData.value.BankDetails:[];
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function addBankData(){
  if (!ABank.value.type) {
    await ElNotification({
      title: "خطا",
      style: "font-family:tahoma;direction:rtl",
      message: "لطفا نوع حساب را انتخاب کنید.",
      type: "error",
    });
    return; // Stop execution if type is not selected
  }

  // Validation logic
  const requiredFields = {
    "حساب بانکی ایران": ["Iban", "AccountNumber", "SortCode", "BankName"],
    "حساب بانکی خارج از ایران": ["Iban", "AccountNumber", "SortCode", "BankName"],
    "کیف پول ارز دیجیتال": ["Token", "WalletAddress", "WalletNetwork"],
  };

  const missingFields = requiredFields[ABank.value.type]?.filter((field) => !ABank.value[field]);

  if (missingFields && missingFields.length > 0) {
    await ElNotification({
      title: "خطا",
      style: "font-family:tahoma;direction:rtl",
      message: `لطفا تمام فیلدهای زیر را پر کنید.`,
      type: "error",
    });
    return; // Stop execution if validation fails
  }
  await UpdateUser('update');
ABank.value = {
    type: "",
    Iban:"",
    BankName:"",
    SortCode:"",
    AccountNumber:"",
    WalletAddress:"",
    WalletNetwork:"",
    Token:""
  };
}
async function UpdateUser(type = 'update'){
  IsWorking.value=true;

  if(type==='update'){
    BankList.value.push(ABank.value);
  }

  AdminData.value.BankDetails= BankList.value
  const response = await fetch('https://inv.tvcnews.co/endPoint/UserUpdate.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify(AdminData.value)
  })
  const data = await response.json();
  IsWorking.value=false;
  if(data?.status===200){
    addBank.value=false
    AdminData.value.Password =null;
    updateAdmin(AdminData.value);
    await ElNotification({
      title: 'Profile',
      style:"font-family:tahoma",
      message: data?.message,
      type: 'success',
    })
    emit('Updated', { message: 'User Updated.' });
  }else{
    await ElNotification({
      title: 'Warning',
      style:"font-family:tahoma",
      message: data?.message,
      type: 'warning',
    })
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function Delete(id) {
  if (id >= 0 && id < BankList.value.length) {
    BankList.value.splice(id, 1);
    await UpdateUser('delete');
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
</script>
<template>
  <el-dialog v-model="addBank" title="Banking Details" width="700">
    <el-row>
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" >
        <el-select
            v-model="ABank.type"
            placeholder="انتخاب نوع حساب بانکی یا ارز دیجیتال"
            size="large"
            style="width: 100%;font-family: Tahoma;"
        >
          <el-option
              :key="1"
              label="حساب بانکی ایران"
              value="حساب بانکی ایران"
              style="font-family: Tahoma"
          />
          <el-option
              :key="2"
              label="حساب بانکی خارج از ایران"
              value="حساب بانکی خارج از ایران"
              style="font-family: Tahoma"
          />
          <el-option
              :key="3"
              label="کیف پول ارز دیجیتال"
              value="کیف پول ارز دیجیتال"
              style="font-family: Tahoma"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="12" style="font-family: Tahoma;direction: rtl" v-if="ABank?.type==='حساب بانکی ایران'">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" >
        <label>شماره شبا</label>
        <el-input
            v-model="ABank.Iban"
            size="large"
            placeholder="شماره حساب شبا"
        />
      </el-col>
      <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24" >
        <label>شماره حساب</label>
        <el-input
            v-model="ABank.AccountNumber"
            size="large"
            placeholder="شماره حساب"
        />
      </el-col>
      <el-col :xl="4" :lg="4" :md="4" :sm="24" :xs="24" >
        <label>کد شعبه</label>
        <el-input
            v-model="ABank.SortCode"
            size="large"
            placeholder="کد شعبه"
        />
      </el-col>
      <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24" >
        <label>نام بانک</label>
        <el-input
            v-model="ABank.BankName"
            size="large"
            placeholder="نام بانک"
        />
      </el-col>
    </el-row>
    <el-row :gutter="12" style="font-family: Tahoma" v-if="ABank?.type==='حساب بانکی خارج از ایران'">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" >
        <label>Iban</label>
        <el-input
            v-model="ABank.Iban"
            size="large"
            placeholder="Iban: GB...."
        />
      </el-col>
      <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24" >
        <label>Account Number</label>
        <el-input
            v-model="ABank.AccountNumber"
            size="large"
            placeholder="Account Number"
        />
      </el-col>
      <el-col :xl="4" :lg="4" :md="4" :sm="24" :xs="24" >
        <label>Sort Code</label>
        <el-input
            v-model="ABank.SortCode"
            size="large"
            placeholder="Sort Code"
        />
      </el-col>
      <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24" >
        <label>Bank Name</label>
        <el-input
            v-model="ABank.BankName"
            size="large"
            placeholder="Bank Name"
        />
      </el-col>
    </el-row>
    <el-row :gutter="12" style="font-family: Tahoma" v-if="ABank?.type==='کیف پول ارز دیجیتال'">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="text-align: right">
        <label>نام ارز دیجیتال</label>
        <el-input
            v-model="ABank.Token"
            size="large"
            placeholder="نام ارز دیجیتال BTC,USDT"
        />
      </el-col>
      <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24" style="text-align: right">
        <label >آدرس کیف پول</label>
        <el-input
            v-model="ABank.WalletAddress"
            size="large"
            placeholder="آدرس کیف پول"
        />
      </el-col>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" style="text-align: right">
        <label >نتورک یا شبکه انتقال</label>
        <el-input
            v-model="ABank.WalletNetwork"
            size="large"
            placeholder=" ERC20 نتورک یا شبکه انتقال"
        />
      </el-col>
    </el-row>
    <template #footer>
      <div class="dialog-footer" style="font-family: Tahoma">
        <el-button @click="addBank = false">انصراف</el-button>
        <el-button  type="primary" @click="addBankData">
          افزودن
        </el-button>
      </div>
    </template>
  </el-dialog>
  <div class="card mt-4">
    <div class="card-header pb-0 p-3">
      <div class="row">
        <div class="col-6 ">
          <argon-button @click="addBank=true" color="dark" variant="gradient" style="font-family: 'dirooz'">
            <i class="fas fa-plus me-2"></i>
            افزودن حساب بانکی یا کیف پول دیجیتال
          </argon-button>
        </div>
        <div class="col-6 " style="text-align: right">
          <h6 class="mb-0" style="font-family: 'dirooz'">روش های دریافت پول</h6>
        </div>

      </div>
    </div>
    <div class="card-body p-3">
      <div class="row">
        <div class="col-md-6 mb-md-0 mb-4" v-for="(item, index) in BankList" :key="index" style="margin-top: 10px">
          <div
              class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row"
          >
            <img
                v-if="item?.type === 'حساب بانکی ایران'"
                class="w-10 me-3 mb-0"
                src="@/assets/img/logos/iran.png"
                alt="logo"
            />
            <img
                v-if="item?.type === 'حساب بانکی خارج از ایران'"
                class="w-10 me-3 mb-0"
                src="@/assets/img/logos/bank.png"
                alt="logo"
            />
            <img
                v-if="item?.type === 'کیف پول ارز دیجیتال'"
                class="w-10 me-3 mb-0"
                src="@/assets/img/logos/crypto.png"
                alt="logo"
            />
            <div style="flex-grow: 1; display: flex; flex-direction: column;font-family: Tahoma">
              <h6 class="mb-0" style="word-break: break-word">
                {{ item?.type === 'حساب بانکی ایران' ? item?.Iban : item?.type === 'حساب بانکی خارج از ایران' ? item?.Iban : item?.WalletAddress }}
              </h6>
              <span style="margin-top: 0;font-size: 12px">{{item?.type === 'حساب بانکی ایران' ? item?.AccountNumber : item?.type === 'حساب بانکی خارج از ایران' ? item?.AccountNumber : item?.WalletNetwork}}</span>
              <span style="margin-top: 0;font-size: 12px">{{item?.type === 'حساب بانکی ایران' ? item?.SortCode : item?.type === 'حساب بانکی خارج از ایران' ? item?.SortCode : item?.Token}}</span>
              <span style="margin-top: 0;font-size: 12px">{{item?.type === 'حساب بانکی ایران' ? item?.BankName : item?.type === 'حساب بانکی خارج از ایران' ? item?.BankName : ''}}</span>
            </div>
            <i
                class="fas fa-trash-alt ms-auto text-dark cursor-pointer"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title
                aria-hidden="true"
                data-bs-original-title="Delete Card"
                aria-label="Delete Card"
                @click="Delete(index)"
            ></i>
            <span class="sr-only">Delete Card</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
